const NOTES = [
    "g",
    "af",
    "a",
    "bf",
    "b",
    "c",
    "df",
    "d"
]

export {NOTES}